<template>
  <div class="sucesso-atendimento">
    <div class="d-flex align-center justify-center py-8 bg-default">
      <v-container>
        <div class="text-center">
          <h4 class="secondary-font">Atendimento finalizado</h4>
          <h5 class="secondary-font text--secondary mt-2">
            Atenção, seu atendimento foi finalizado, seus documentos já estão prontos
          </h5>
        </div>
      </v-container>
    </div>
    <div class="content container" :style="{ color: $vuetify.theme.themes.light.primary }">
      <div>
        <v-icon color="primary" size="80">mdi-check-decagram-outline</v-icon>
      </div>
      <div class="title">Parabéns</div>
      <div>Seu atendimento foi concluído com sucesso, a equipe Limer te deseja um excelente dia 😊</div>
    </div>
    <v-row no-gutters justify="center" align="center" class="my-10">
      <v-btn
        @click="$router.push({ name: 'verificacao-cpf-atendimento' })"
        color="primary"
        class="secondary-font text-capitalize font-weight-black"
        rounded
      >
        Novo atendimento
      </v-btn>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'SucessoAtendimento'
}
</script>

<style scoped>
.content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  border-radius: 10px;
  /* Rectangle 24 */
  background-color: #fff;
  margin-right: auto;
  margin-left: auto;
  margin-top: 5vh;
  width: 80vw;
  padding: 20px;
  gap: 20px;
}

.rating-area {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 20px;
  text-align: center;
}
</style>
